import React, { useContext } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { WIDGET_TYPES } from 'common/Widgets/constants';

import { CommunityViewWidgetModalContext } from './CommunityViewWidgetModalContext';
import Widget from '../../../common/Widgets/Widget/Widget';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: var(--background-gray);
  padding: 20px;

  &.amenities {
    max-width: 732px;
    max-height: 477px;
    box-sizing: border-box;
    overflow-y: auto;
    align-items: baseline;
  }
`;

const CommunityViewWidgetModalContent = () => {
  const {
    type,
    name,
    note,
    competitors,
    careTypes,
    roomTypes,
    roomTypesPriceDisplay,
    careLevels,
    medicationLevels,
    careLevelsStatsType,
    medicationLevelsStatsType,
    reviewSources,
    reviewCategories,
    amenityCategories,
    swotCategories,
    contractTypes,
    communityContractType,
    communityContractSelectionType,
    priceDisplay,
    initialRange,
    initialFormat,
    initialOrientation,
    displayValue,
    groupBy,
  } = useContext(CommunityViewWidgetModalContext);

  return (
    <Container className={classNames('widget-modal-content', { amenities: type === WIDGET_TYPES.AMENITIES })}>
      <Widget
        isModalPreview
        type={type}
        name={name}
        note={note}
        initial_settings={{
          range: initialRange,
          format: initialFormat,
          orientation: initialOrientation,
          display_value: displayValue,
          price_display: priceDisplay,
        }}
        group_by={groupBy}
        filters={{
          competitors,
          careTypes,
          roomTypes,
          roomTypesPriceDisplay,
          careLevels,
          medicationLevels,
          reviewSources,
          reviewCategories,
          swotCategories,
          amenityCategories,
          contractTypes,
          careLevelsStatsType,
          medicationLevelsStatsType,
          communityContractType,
          communityContractSelectionType,
        }}
      />
    </Container>
  );
};

export default CommunityViewWidgetModalContent;
